import { FhirBundleSdk } from "@metriport/fhir-sdk";
import type { Suspect } from "../../../../../api/suspects";
import { getSuspectRows } from "./suspect-rows";

export const metadata = {
  tableType: "Suspects",
  displayName: "Suspects",
  getRows: (_bundle: FhirBundleSdk, suspects?: Suspect[]) => getSuspectRows({ suspects }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Only include fields that are visible in the table:
    // Condition, ICD 10 Code, Suspect Group
    const searchableFields = ["condition", "code", "group"];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
